import { FirestoreDataConverter } from "firebase/firestore";
import { Product } from "lib-shared-code";
import { PartialConverter } from "../types";
import { genericConverter } from "./generic-converter";

export const productConverter: FirestoreDataConverter<Product> &
  PartialConverter<Product> = genericConverter<Product>();
